<template>
  <a-layout>
    <a-space>
      <vxe-input v-model="query['no']" placeholder="business.label.printNo" size="small" type="search" @search-click="search"/>
      <vxe-input v-model="query['name']" placeholder="business.label.printName" size="small" type="search" @search-click="search"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.no" width="150"/>
      <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.name" width="200"/>
      <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
      <vxe-column :edit-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('statementModal',row.statement,row)}}" field="statement" title="business.label.printStatement"/>
      <vxe-column :edit-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('templateModal',row.template,row)}}" field="template" title="business.label.printTemplate"/>
      <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperLength" title="business.label.paperLength" width="80"/>
      <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperWidth" title="business.label.paperWidth" width="80"/>
      <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperSize" title="business.label.paperSize" width="80"/>
      <vxe-column field="enterprise.name" title="business.label.enterprise" width="100"/>
      <vxe-column field="warehouse.name" title="business.label.warehouse" width="100"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
    <TextAreaModal ref="statementModal" title="打印语句" @change="(e,row)=>{row.statement = e}"/>
    <TextAreaModal ref="templateModal" title="打印模板" @change="(e,row)=>{row.template = e}"/>
  </a-layout>
</template>

<script>
import { findAll, saveAll } from '@/api/Api'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { Print } from '@/api/dto/admin/Print'

export default {
  name: 'PrintTable',
  components: {
    TextAreaModal
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      query: { no: '', name: '' },
      contentSize: 0,
      page: 1,
      size: 15,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.77),// 表格竖向滚动条
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        no: [
          { required: true, type: 'string', message: '编号不能为空' }
        ],
        name: [
          { required: true, type: 'string', message: '名称不能为空' }
        ],
        statement: [
          { required: true, type: 'string', message: '打印语句不能为空' }
        ],
        template: [
          { required: true, type: 'string', message: '打印模板不能为空' }
        ]
      }
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    dblclick(row) {
      if (!this.$refs.table.isEditByRow(row)) {
        this.$emit('dblClick', row)
      }
    },
    add() {
      this.data.push(new Print())
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    },
    refresh() {
      this.loading = true
      findAll('printFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new Print(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.refresh()
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          return item.toJSONObject()
        })
        saveAll('printPersister', saveData).then(res => {
          if (res.success) {
            this.refresh()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    uploadTemplate() {
    }
  }
}
</script>